import IconCard, { CardDescription, CardValue } from "components/company/cards/IconCard";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import parseDateYmd from "lib/utils/parseDateYmd";
import numeral from "numeral";
import type { IAmericanCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/AmericanCompanyIssuerTopLevel.generated";
import CircleDollarSign from "components/svg/CircleDollarSign";
import type { IBrazilianRealEstateFundTopLevelFragment } from "lib/fragments/__generated__/BrazilianRealEstateFundTopLevel.generated";
import { useIntl } from "react-intl";
import colors from "tailwindcss/colors";

interface IMarketCapCardProps {
  issuer:
    | IBrazilianCompanyIssuerTopLevelFragment
    | IBrazilianRealEstateFundTopLevelFragment
    | IAmericanCompanyIssuerTopLevelFragment;
}

export default function MarketCapCard({ issuer }: IMarketCapCardProps) {
  const intl = useIntl();

  if (!issuer.marketCapitalization || issuer.marketCapitalization.totalCapitalization === 0) {
    return null;
  }

  const isAmericanIssuer = issuer.__typename === "AmericanCompanyIssuer";

  return (
    <IconCard primaryColor={colors.blue[600]} secondaryColor={colors.indigo[50]} icon={<CircleDollarSign />}>
      <CardValue title={numeral(issuer.marketCapitalization.totalCapitalization).format("0,0")}>
        {isAmericanIssuer ? "$" : "R$"}
        {numeral(issuer.marketCapitalization.totalCapitalization).format("0.0a").replace(".0", "").toUpperCase()}
      </CardValue>
      <CardDescription>
        Market Cap •{" "}
        {intl.formatDate(parseDateYmd(issuer.marketCapitalization.asOfDate), {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        })}
      </CardDescription>
    </IconCard>
  );
}
